module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/video-row/video-row.style.scss
// module id = 739
// module chunks = 2